function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOutletPressure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2764",
    d: "M20 2.5A17.5 17.5 0 1 1 2.5 20 17.5 17.5 0 0 1 20 2.5M20 0a19.979 19.979 0 1 0 .043 0H20",
    style: {
      fill: "#00c4ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2765",
    d: "M16.624 16.845a3.377 3.377 0 0 0 6.752 0c0-1.822-3.376-6.5-3.376-6.5s-3.376 4.683-3.376 6.5m4.876-1.093a.909.909 0 0 1 .858.832.858.858 0 1 1-.858-.832m7.456-2.485-.568-1.716-.023-.061a9.325 9.325 0 1 0-9.824 13.033v3.02H9.054v1.25h16.8l-.023-1.25h-4.79v-3a9.349 9.349 0 0 0 2.09-.509 9.31 9.31 0 0 0 5.825-10.771m-1.747 5.397a8.065 8.065 0 1 1 0-6.685l.54 1.622a8 8 0 0 1-.543 5.063m-1.333 11.431.022 1.25H9.054v-1.25zm6.532-.747-5.036 5.089-.182-10z",
    style: {
      fill: "#f5f5f5"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutletPressure);
export default __webpack_public_path__ + "static/media/outlet-pressure.107a9b94a349b257c94cc3f5ab3e9f08.svg";
export { ForwardRef as ReactComponent };